import { render, staticRenderFns } from "./cardAnimation.vue?vue&type=template&id=54a883a2&"
import script from "./cardAnimation.vue?vue&type=script&lang=js&"
export * from "./cardAnimation.vue?vue&type=script&lang=js&"
import style0 from "./cardAnimation.vue?vue&type=style&index=0&id=54a883a2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a883a2')) {
      api.createRecord('54a883a2', component.options)
    } else {
      api.reload('54a883a2', component.options)
    }
    module.hot.accept("./cardAnimation.vue?vue&type=template&id=54a883a2&", function () {
      api.rerender('54a883a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/cardAnimation.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/cardAnimation.vue
// module id = GMl5
// module chunks = 0